import React from "react";
import { Box, Slide, Container } from "@mui/material";
import { HomeContent } from "./content/HomeContent";
import { AboutUsContent } from "./content/AboutUsContent";
import { ServiceContentOne } from "./content/ServiceContentOne";
import { ServiceContentTwo } from "./content/ServiceContentTwo";
import { ExperienceContent } from "./content/ExperienceContent";

export const Content = ({ translate }) => {
  return (
    <Box component="div">
      <img
        src="/images/sbpcon_cover_main.png"
        alt="S B P CON images cover"
        width="100%"
      />
      <Container maxWidth="lg" sx={{ padding: "15px" }}>
        <section id="aboutUs"></section>

        <Box
          component="div"
          sx={{ marginBottom: "35px" }}
          data-aos="fade-up"
          data-aos-offset="200"
        >
          <HomeContent translate={translate} />
        </Box>
        <section id="serviceUs"></section>

        <Box
          sx={{ marginBottom: "70px" }}
          data-aos="fade-up"
          data-aos-offset="200"
        >
          <AboutUsContent translate={translate} />
        </Box>
        <Box
          sx={{ marginBottom: "20px" }}
          data-aos="fade-up"
          data-aos-offset="200"
        >
          <ServiceContentOne translate={translate} />
        </Box>

        <Box
          sx={{ marginBottom: "20px" }}
          data-aos="fade-up"
          data-aos-offset="200"
        >
          <ServiceContentTwo translate={translate} />
        </Box>

        <Slide
          direction="up"
          in={true}
          timeout={300}
          mountOnEnter
          unmountOnExit
        >
          <Box sx={{ marginBottom: "20px" }}>
            <ExperienceContent translate={translate} />
          </Box>
        </Slide>
        <section id="contactUs"></section>
      </Container>
    </Box>
  );
};
